import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios'; 
   
const EditDepartment = ({ show, onClose, departmentId, onUpdated }) => {
    const [name, setName] = useState('');
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [description, setDescription] = useState('');
    const [errors, setErrors] = useState({});
    const [nameLengthError, setNameLengthError] = useState('');
    const [descLengthError, setDescLengthError] = useState('');  

    // Fetch the current department data when the modal is opened
    useEffect(() => {
        if (show && departmentId) {
            axios.get(`${baseURL}/department/${departmentId}`)
                .then(response => {
                    const { department_name, description } = response.data.data;
                    setName(department_name || '');
                    setDescription(description || ''); 
                })
                .catch(error => {
                    console.error("Error fetching department:", error);
                });
        }
    }, [show, departmentId]);

    const handleNameChange = (e) => {
        let value = e.target.value || '';
        value = value.charAt(0).toUpperCase() + value.slice(1); // Capitalize first letter
        setName(value);

        if (value.length <= 300) {
            setNameLengthError('');
        }
    };

    const handleDescriptionChange = (e) => {
        let value = e.target.value || '';
        value = value.charAt(0).toUpperCase() + value.slice(1); // Capitalize first letter
        setDescription(value);

        if (value.length <= 500) {
            setDescLengthError('');
        }
    };

    const handleSubmit = () => {
        setErrors({});
        setNameLengthError('');
        setDescLengthError('');

        const safeName = name ?? '';
        const safeDescription = description ?? '';

        if (safeName.trim().length === 0) {
            setErrors(prev => ({
                ...prev,
                department_name: "This field is required"
            }));
            return;
        }

        if (safeName.length > 300) {
            setNameLengthError('Limit reached (max 300 characters)');
            return;
        }

        if (safeDescription.length > 500) {
            setDescLengthError('Limit reached (max 500 characters)');
            return;
        }

        axios.put(`${baseURL}/department/${departmentId}`, {
            department_name: safeName,
            description: safeDescription,
        })
        .then(response => {
            onUpdated();
            onClose();
            if (onUpdated) onUpdated();
            toast.success("Department Updated successfully!"); 
        })
        .catch(error => {
            if (error.response?.status === 400 && error.response.data.errors) {
                setErrors(error.response.data.errors);
            } else {
                console.error("Update failed:", error);
            }
        });
    };



    return (
        <Modal show={show} size="md">
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Update Department</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className='text-white'>×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        {/* <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Department<span className="required">*</span></label>
                            <input type="text" className="form-control" placeholder="Enter Department" defaultValue={'Management'}/>
                        </div> */}

                        <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">
                            Department <span className="required">*</span>
                            </label>
                            <input
                                type="text"
                                className={`form-control ${errors.department_name ? 'is-invalid' : ''}`}
                                placeholder="Enter Department"
                                value={name}
                                onChange={handleNameChange}
                            />
                            {errors.department_name && (
                                <div className="invalid-feedback">{errors.department_name}</div>
                            )}
                            {nameLengthError && (
                                <span className="text-danger">{nameLengthError}</span>
                            )}
                        </div>

                        {/* <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Description</label>
                            <textarea rows={4} className="form-control h-auto" name="comment" placeholder="Description" defaultValue={"In HR management, this department oversees the strategic planning, organization, and execution of company goals. It focuses on leadership, employee development, and optimizing overall company performance."} />
                        </div> */}
                         <div className="col-lg-12 mb-2">
                            <label className="text-black font-w500 fs-7">Description</label>
                            <textarea
                                rows={4}
                                className={`form-control ${errors.description ? 'is-invalid' : ''}`}
                                placeholder="Description"
                                value={description}
                                onChange={handleDescriptionChange}
                            />
                            {descLengthError && (
                                <span className="text-danger">{descLengthError}</span>
                            )}
                        </div> 
                    </div>
                    {/* <div className="d-flex align-items-center justify-content-center gap-3 mt-4 mb-4">
                        <Link type="reset" className="btn btn-sm btn-secondary" onClick={onClose}>Cancel</Link>
                        <Link type="submit" className="btn btn-sm btn-primary" onClick={onClose}>Update Department</Link>
                    </div> */}
                         {/* <div className="d-flex justify-content-center gap-3 mt-4 mb-4">
                            <Button variant="secondary" size="sm" onClick={onClose}>Cancel</Button>
                            <Button variant="primary" size="sm" onClick={handleSubmit}>Update Department</Button>
                        </div> */}
                        <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                            <button type="submit" className="btn btn-sm btn-primary" onClick={handleSubmit}>Update Department
                            <i className="fas fa-angle-double-right ms-2"></i>
                            </button>
                        </div>
                </div>
            </div>
        </Modal>
    );
};

export default EditDepartment;
